<template>
  <v-dialog persistent v-model="joinDialog.status" max-width="300px">
    <v-card>
      <v-card-title class="overline">
        Join Mission
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field v-model="joinDialog.name" label="Player Name"></v-text-field>
        <v-select v-model="joinDialog.class" :items="joinDialog.classes" label="Player Class"></v-select>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined color="grey" @click="joinDialog.status = false">Cancel</v-btn>
        <v-btn outlined color="primary" @click="addNewPlayer">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Cookies from 'js-cookie'
const firebase = require('firebase')
const database = firebase.database()
export default {
  name: 'joinDialog',
  data: () => ({
    joinDialog: {}
  }),
  created () {
    this.joinDialog = this.$store.state.joinDialog
    this.joinDialog.name = Cookies.get('Name')
  },
  methods: {
    addNewPlayer () {
      Cookies.set('Name', this.joinDialog.name, { expires: 7 })
      database.ref('/avatar').once('value', e => {
        let data = {
          avatar: e.val()[Math.floor(Math.random() * e.val().length)],
          class: this.joinDialog.class,
          color: '',
          leader: false,
          name: this.joinDialog.name
        }
        database.ref('/game_record/' + this.$store.state.joinCard.groupKey + '/players').once('value', e => {
          let list = e.val()
          list != null ? list.push(data) : list = [data]
          database.ref('/game_record/' + this.$store.state.joinCard.groupKey + '/players').set(list)
        })
        this.$store.commit('setSnackBar', {
          icon: 'far fa-check-circle',
          color: 'primary',
          status: true,
          text: 'Joined',
          timeout: 2000
        })
        this.$store.commit('setJoinDialogStatus', false)
      })
    }
  }
}
</script>

<style scoped>

</style>
